import { TLShape, track } from '@tldraw/tldraw'
import { observer } from 'mobx-react-lite'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { GeneratingOverlay } from 'components/Previews/components/GeneratingOverlay'
import { pageToViewport } from '../../helpers'

interface Props {
  shape: TLShape
}

// Positions the shared content-generation loader over the unflattening image in
// screen-space (unlike ShapeOverlay, which scales by zoom and would shrink the
// loader text). Sizing the box in actual pixels lets GeneratingOverlay render at
// its natural size — matching the calendar — while still tracking the image.
const UnflattenOverlay = track(
  observer(({ shape }: Props) => {
    const editor = useEditor()
    const bounds = editor.getShapePageBounds(shape)
    if (!bounds) return null

    const topLeft = pageToViewport(editor, bounds.point)
    const zoom = editor.getZoomLevel()

    return (
      <div
        style={{
          position: 'absolute',
          top: topLeft.y,
          left: topLeft.x,
          width: bounds.w * zoom,
          height: bounds.h * zoom,
        }}
      >
        <GeneratingOverlay isVisible message="Extracting layers…" blurBackdrop centered />
      </div>
    )
  }),
)

export { UnflattenOverlay }
